import React, { useState } from "react";

// i18n
import { useTranslation, whatsappLink } from "../../i18n";

export default function FormContactComponents() {
  const { t } = useTranslation();
  // state
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    message: "",
  });

  // function
  const handleOrderClick = () => {
    const message = t.contact.waMessage(
      `${formData.firstName} ${formData.lastName}`.trim(),
      formData.email,
      formData.message
    );
    window.open(whatsappLink(message), "_blank");
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  return (
    <div className="form">
      <div className="row">
        <div className="col-6">
          <input
            className="input-bale form-control form-control-lg"
            type="text"
            name="firstName"
            placeholder={t.contact.firstName}
            value={formData.firstName}
            onChange={handleChange}
          />
        </div>
        <div className="col-6">
          <input
            className="input-bale form-control form-control-lg"
            type="text"
            name="lastName"
            placeholder={t.contact.lastName}
            value={formData.lastName}
            onChange={handleChange}
          />
        </div>
        <div className="col-12">
          <input
            className="input-bale form-control form-control-lg"
            type="email"
            name="email"
            placeholder={t.contact.email}
            value={formData.email}
            onChange={handleChange}
          />
        </div>
        <div className="col-12">
          <textarea
            className="input-bale form-control form-control-lg"
            placeholder={t.contact.message}
            name="message"
            rows={5}
            value={formData.message}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-12">
          <button
            onClick={handleOrderClick}
            className="btn btn-detail w-100 rounded-0 mt-2"
          >
            {t.contact.send}
          </button>
        </div>
      </div>
    </div>
  );
}
